/**
 * External Dependencies
 */
import 'jquery';
import AOS from 'aos';
import 'slick-carousel';
import Modal from 'bootstrap/js/dist/modal';

$(document).ready(() => {
  resizePictures();
  function resizePictures() {
    let pictures = document.querySelectorAll('.img--carre');
    if (pictures.length != 0) {
      for (let i = 1; i <= pictures.length; i++) {
        let picturesWidth = pictures[i - 1];
        let widthPictures = picturesWidth.clientWidth;
        if (i - 1 == pictures.length) {
          pictures[i].style.height = widthPictures + 'px';
        } else {
          pictures[i - 1].style.height = widthPictures + 'px';
        }
      }
    }
  }
  setTimeout(function () {
    if ($('.home:not(.home .header--home)').length) {
      AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 1190, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 400, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
      });
    } else {
      AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
        initClassName: 'aos-init', // class applied after initialization
        animatedClassName: 'aos-animate', // class applied on animation
        useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
        disableMutationObserver: false, // disables automatic mutations' detections (advanced)
        debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
        throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

        // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
        offset: 240, // offset (in px) from the original trigger point
        delay: 0, // values from 0 to 3000, with step 50ms
        duration: 400, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-center', // defines which position of the element regarding to window should trigger the animation
      });
    }
  }, 1500);

  $('.p--blue').lettering();
  $('.shop__text').lettering();

  // var btnSong = document.querySelectorAll('.card__podcast');
  // var audio = document.querySelectorAll('.audio');
  // var temp2;
  // var bool = false;

  // $('.card--participer-click').on('click', function(e) {
  //   console.log($('.shopify-buy__btn'));
  //   $('.shopify-buy__btn').click();
  // });

  // if($(".card__podcast").length) {
  //   for (let index = 0; index < btnSong.length; index++) {
  //     btnSong[index].addEventListener('click', function (e) {
  //       e.preventDefault();
  //       for (let index = 0; index < btnSong.length; index++) {
  //         if(btnSong[index].classList.contains('card__podcast--play')) {
  //           btnSong[index].classList.remove('card__podcast--play');
  //           audio[index].pause();
  //         }
  //       }
  //       if (temp2 == index && bool == true) {
  //         bool = false;
  //       } else {
  //         btnSong[index].classList.add('card__podcast--play');
  //         audio[index].play();
  //         bool = true;
  //       }
  //       temp2 = index;
  //     });
  //   }
  // }

  if ($('.slider--arrow') != null) {
    $('.slider--arrow').on('click', function (e) {
      let number = $(this).attr('data-number');
      var listeJobs = document.querySelectorAll('.slider__el');
      var jobsContainer = document.querySelector('.photos__container');
      var tailleCardJobs = $('.slider__el').width() + 30;
      let count = parseInt($(this).attr('data-count'));

      if (count >= listeJobs.length - 1) {
        count = 0;
        console.log('if' + count);
      } else {
        console.log('else');
        count = count + 1;
      }
      $(this).attr('data-count', count);

      jobsContainer.style.transform =
        'translate(-' + tailleCardJobs * count + 'px)';
    });
  }
  $('#team-container').each(function () {
    const $container = $(this);
    const $card = $container.find('.card-team');
    const count = $card.length;

    $card.on('click', function () {
      const $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');

        $container.find('.team-description').slideUp(400, function () {
          $(this).remove();
        });
      } else {
        // get text
        console.log('else');
        const text = $this.data('description');
        const winW = $(window).width();
        const template = `<div class="team-description row is-red"><div class="col-12 col-md-10 m-auto">
                  ${text}
              </div> </div>`;
        console.log(template);

        $card.removeClass('active');
        $this.addClass('active');

        $container.find('.team-description').slideUp(400, function () {
          $(this).remove();
        });

        // get the number of columns, to know where to insert template
        let columns = 1;
        if ($('#sm').is(':visible')) {
          columns = 2;
        }
        if ($('#md').is(':visible')) {
          columns = 3;
        }

        // append the template after the right column
        setTimeout(function () {
          const index = $this.index() + 1;
          console.log($this.parent());
          let eq = 0;
          if (index % columns === 0) {
            eq = index - 1;
          } else {
            eq = index + (columns - (index % columns) - 1);
            if (eq >= count) {
              eq = count - 1;
            }
          }
          console.log(index);

          $(template)
            .insertAfter($card.eq(eq))
            .slideDown(400, function () {
              $('html, body')
                .stop(true, true)
                .animate(
                  {
                    scrollTop: $this.offset().top - 100,
                  },
                  500
                );
            });
        }, 500);
      }
    });
  });

  $('.burger').on('click', function (e) {
    $('body').toggleClass('nav--open');
  });

  $('body').addClass('nav-show-top');

  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var st = $(this).scrollTop();

    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos || currentScrollPos == 0) {
      if (currentScrollPos < 700) {
        $('body').addClass('nav-show nav-show-top');
        $('.header--home').css('opacity', 1);
      } else {
        $('body').addClass('nav-show');
      }
    } else {
      if (currentScrollPos > 700) {
        $('body').removeClass('nav-show nav-show-top');
        $('.header--home').css('opacity', 0);
      }
    }

    prevScrollpos = currentScrollPos;
  };

  // Texte qui réagit au scroll

  if ($('#text-path').length > 0) {
    var textPath = document.querySelector('#text-path');

    var textContainer = document.querySelector('#text-container');

    var path = document.querySelector(textPath.getAttribute('href'));

    var pathLength = path.getTotalLength();
    console.log(pathLength);

    function updateTextPathOffset(offset) {
      textPath.setAttribute('startOffset', offset);
    }

    updateTextPathOffset(pathLength);

    function onScroll() {
      requestAnimationFrame(function () {
        var rect = textContainer.getBoundingClientRect();
        var scrollPercent = rect.y / window.innerHeight;
        // console.log(scrollPercent);
        updateTextPathOffset(scrollPercent * 2 * pathLength - 400);
        // console.log(scrollPercent * 2 * pathLength  );
      });
    }

    window.addEventListener('scroll', onScroll);
  }

  $('.svg__competences path').on('click', function (e) {
    let texts = document.querySelectorAll('.competences__text p');
    let number = $(this).attr('number');
    let color = $(this).attr('fill');
    console.log(color);
    for (let index = 0; index < texts.length; index++) {
      texts[index].classList.add('d-none');
      if (texts[index].classList.contains('text--' + number)) {
        texts[index].classList.remove('d-none');
      }
      $('.competences__text').css('border-color', color);
    }
  });
  setTimeout(function () {
    $('.slick').slick({
      infinite: true,
      fade: true,
      dots: false,
      prevArrow:
        '<div class="arrow arrow--prev"><svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4531 10C21.4531 10.8438 20.7969 11.5 20 11.5H5.60938L10.5312 16.4688C11.1406 17.0312 11.1406 18.0156 10.5312 18.5781C10.25 18.8594 9.875 19 9.5 19C9.07812 19 8.70312 18.8594 8.42188 18.5781L0.921875 11.0781C0.3125 10.5156 0.3125 9.53125 0.921875 8.96875L8.42188 1.46875C8.98438 0.859375 9.96875 0.859375 10.5312 1.46875C11.1406 2.03125 11.1406 3.01562 10.5312 3.57812L5.60938 8.5H20C20.7969 8.5 21.4531 9.20312 21.4531 10Z" fill="#005D8F"/></svg></div>',
      nextArrow:
        '<div class="arrow arrow--next"><svg width="27" height="23" viewBox="0 0 27 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.869144 11.375C0.869144 10.3555 1.66211 9.5625 2.625 9.5625L20.0137 9.5625L14.0664 3.55859C13.3301 2.8789 13.3301 1.68945 14.0664 1.00976C14.4063 0.669921 14.8594 0.499999 15.3125 0.499999C15.8223 0.499999 16.2754 0.669921 16.6152 1.00976L25.6777 10.0723C26.4141 10.752 26.4141 11.9414 25.6777 12.6211L16.6152 21.6836C15.9355 22.4199 14.7461 22.4199 14.0664 21.6836C13.3301 21.0039 13.3301 19.8145 14.0664 19.1348L20.0137 13.1875L2.625 13.1875C1.66211 13.1875 0.869143 12.3379 0.869144 11.375Z" fill="#005D8F"/></svg></div>',
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }, 200);

  let numberImage = 0;
  let direction = '';
  let arraySize = 0;

  if ($('.section--timeline').length > 0) {
    $('.section--timeline .timeline__card').on('click', function (e) {
      numberImage = $(this).attr('data-img');
      arraySize = $(this).attr('data-size');

      $('.section--timeline .pop--up--timeline').addClass('open');
      $('.section--timeline .timeline__pop__img--' + numberImage).addClass(
        'open'
      );

      $('.section--timeline .pop--up--timeline__button--close').on(
        'click',
        function (e) {
          $('.section--timeline .pop--up--timeline').removeClass('open');
          $(
            '.section--timeline .timeline__pop__img--' + numberImage
          ).removeClass('open');
        }
      );

      // window.addEventListener("keydown", function (event) {
      //   if (event.defaultPrevented) {
      //     return; // Do nothing if the event was already processed
      //   }

      //   switch (event.key) {
      //     case "Left": // IE/Edge specific value
      //       direction = 'left';
      //       changeImage(direction, arraySize);
      //     case "ArrowLeft":
      //       // Do something for "left arrow" key press.
      //       direction = 'left';
      //       changeImage(direction, arraySize);
      //       break;
      //     case "Right": // IE/Edge specific value
      //       direction = 'right';
      //       changeImage(direction, arraySize);
      //     case "ArrowRight":
      //       direction = 'right';
      //       changeImage(direction, arraySize);
      //       // Do something for "right arrow" key press.
      //       break;
      //     case "Esc": // IE/Edge specific value
      //       $('.section--timeline .pop--up--timeline').removeClass('open');
      //       $('.section--timeline .timeline__pop__img--' + numberImage).removeClass('open');
      //     case "Escape":
      //       $('.section--timeline .pop--up--timeline').removeClass('open');
      //       $('.section--timeline .timeline__pop__img--' + numberImage).removeClass('open');
      //       break;
      //     default:
      //       return; // Quit when this doesn't handle the key event.
      //   }
      //   event.preventDefault();
      // }, true);
    });

    $('.section--timeline .pop--up--timeline__button').on(
      'click',
      function (e) {
        direction = $(this).attr('data-button');
        changeImage(direction, arraySize);
      }
    );

    function changeImage(direction, arraySize) {
      console.log(direction);
      if (direction == 'left') {
        numberImage--;
      } else {
        numberImage++;
      }

      if (numberImage < 0) {
        numberImage = arraySize;
      }
      if (numberImage > arraySize) {
        numberImage = 0;
      }
      console.log(numberImage);
      updateImage(numberImage);
    }

    function updateImage(numberImage) {
      $('.section--timeline .timeline__pop__img').each(function () {
        $(this).removeClass('open');
      });
      $('.section--timeline .timeline__pop__img--' + numberImage).addClass(
        'open'
      );
    }
  }

  if ($('.section--4-card').length > 0) {
    let numberImageCard = 0;
    let directionCard = '';
    let arraySizeCard = 0;

    $('.digital--card .no-link').on('click', function (e) {
      e.preventDefault();
      numberImageCard = $(this).attr('data-img');
      arraySizeCard = $(this).attr('data-size');
      console.log(arraySizeCard);

      $('.section--4-card .pop--up--timeline').addClass('open');
      $('.section--4-card .timeline__pop__img--' + numberImageCard).addClass(
        'open'
      );

      $('.section--4-card .pop--up--timeline__button--close').on(
        'click',
        function (e) {
          $('.section--4-card .pop--up--timeline').removeClass('open');
          $(
            '.section--4-card .timeline__pop__img--' + numberImageCard
          ).removeClass('open');
        }
      );

      // window.addEventListener("keydown", function (event) {
      //   if (event.defaultPrevented) {
      //     return; // Do nothing if the event was already processed
      //   }

      //   switch (event.key) {
      //     case "Left": // IE/Edge specific value
      //       directionCard = 'left';
      //       changeImageCard(directionCard, arraySizeCard);
      //     case "ArrowLeft":
      //       // Do something for "left arrow" key press.
      //       directionCard = 'left';
      //       changeImageCard(directionCard, arraySizeCard);
      //       break;
      //     case "Right": // IE/Edge specific value
      //       directionCard = 'right';
      //       changeImageCard(directionCard, arraySizeCard);
      //     case "ArrowRight":
      //       directionCard = 'right';
      //       changeImageCard(directionCard, arraySizeCard);
      //       // Do something for "right arrow" key press.
      //       break;
      //     case "Esc": // IE/Edge specific value
      //       $('.section--4-card .pop--up--timeline').removeClass('open');
      //       $('.section--4-card .timeline__pop__img--' + numberImageCard).removeClass('open');
      //     case "Escape":
      //       $('.section--4-card .pop--up--timeline').removeClass('open');
      //       $('.section--4-card .timeline__pop__img--' + numberImageCard).removeClass('open');
      //       break;
      //     default:
      //       return; // Quit when this doesn't handle the key event.
      //   }
      //   event.preventDefault();
      // }, true);
    });

    $('.section--4-card .pop--up--timeline__button').on('click', function (e) {
      directionCard = $(this).attr('data-button');
      changeImageCard(directionCard, arraySizeCard);
    });

    function changeImageCard(directionCard, arraySizeCard) {
      console.log(directionCard, numberImageCard, arraySizeCard);
      if (directionCard == 'left') {
        numberImageCard--;
      } else {
        numberImageCard++;
      }

      if (numberImageCard < 0) {
        numberImageCard = arraySizeCard;
      }
      if (numberImageCard > arraySizeCard) {
        numberImageCard = 0;
      }
      console.log(numberImageCard);
      updateImageCard(numberImageCard);
    }

    function updateImageCard(numberImageCard) {
      $('.section--4-card .timeline__pop__img').each(function () {
        $(this).removeClass('open');
      });
      $('.section--4-card .timeline__pop__img--' + numberImageCard).addClass(
        'open'
      );
    }
  }

  $('.Pays path').on('click', function (e) {
    let $this = $(this);
    let pays = $this
      .attr('class')
      .toLowerCase()
      .substring(0, 3)
      .replace(/\s+/g, '');
    console.log(pays);

    $('.Pays').each(function () {
      $(this).removeClass('actif');
    });

    $this.parent().addClass('actif');

    $('.map__content').addClass('opacity');

    $('.country__card').each(function () {
      let $this = $(this);
      $this.removeClass('open');
      if ($this.attr('id') == pays) {
        $this.addClass('open');
      }
    });
  });

  if ($('.custom-modal-newsletter').length > 0) {
    const myModal = document.getElementById('exampleModal');
    const dateTimeRefreshACF =
      document.getElementById('date-time-modal').innerText;
    const modal = new Modal(myModal); // Instantiates your modal
    const lastViewed = getCookie('cookieModalDateLastViewed');
    var currentdate = new Date();
    currentdate = Date.now();
    let dateLastUpdated = new Date(dateTimeRefreshACF).getTime();

    console.log('last viewed', parseInt(lastViewed))
    console.log('update', dateLastUpdated)
    console.log('current date', currentdate);
    console.log(parseInt(dateLastUpdated) > lastViewed)
    if (!lastViewed) {
      setCookie('cookieModalDateLastViewed', currentdate, 7);
      modal.show();
    } else {
      if (parseInt(dateLastUpdated) > lastViewed) {
        setCookie('cookieModalDateLastViewed', currentdate, 7);
        modal.show();
      } else {
        modal.hide();
      }
    }
    function setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    function getCookie(cname) {
      let name = cname + '=';
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }
  }
  function resetFiltersAndClearUrl() {
    const category = document.getElementById('category');
    const search = document.getElementById('search');
    // Reset all filters here
    if (category) {
      category.value = 'all';
    }
    if (search) {
      search.value = '';
    }
  
    // Clear the URL
    // history.replaceState(null, null, window.location.pathname);
  }  

  const resetFilters = document.getElementById('reset-filters-educational');
  if (resetFilters) {
    resetFilters.addEventListener('click', resetFiltersAndClearUrl);
  }

  function downloadEducationaAllLinks(e) {
    if (!e.target.dataset.downloadLink) return;

    const allLinks = document.querySelectorAll(`[data-download="${e.target.dataset.downloadLink}"]`);
    allLinks.forEach((link) => {
      link.click();
    })
  }
  const downloadEducationalLinks = document.querySelectorAll('[data-download-link]');
  if (downloadEducationalLinks) {
    downloadEducationalLinks.forEach((link) => {
      link.addEventListener('click', downloadEducationaAllLinks);
    });
  }
});
